import { Panel, PanelType, getPanelType } from "./Panel";

export interface PanelConfig {
  title: string;
  panelConfigs: Map<PanelType, PanelTypeSpecificConfig>;
}

export interface PanelTypeSpecificConfig {
  panelType: PanelType;
  startProgram: number;
  programs: Map<number, Program>;
}

export interface Program {
  name: string;
  description: string;
  programNumber: number;
}

export function getFallbackConfig(): PanelConfig {
  const programs = new Map<number, Program>();

  programs.set(1, {
    name: "P1",
    description: "",
    programNumber: 1,
  });

  programs.set(2, {
    name: "P2",
    description: "",
    programNumber: 2,
  });

  programs.set(3, {
    name: "P3",
    description: "",
    programNumber: 3,
  });

  const panelConfig = {
    panelType: PanelType.EDGE,
    startProgram: 1,
    programs,
  };

  const panelConfigs = new Map<PanelType, PanelTypeSpecificConfig>();

  panelConfig.panelType = PanelType.EDGE;
  panelConfigs.set(panelConfig.panelType, panelConfig);

  panelConfig.panelType = PanelType.SLIM;
  panelConfigs.set(panelConfig.panelType, panelConfig);

  panelConfig.panelType = PanelType.HYDRY;
  panelConfigs.set(panelConfig.panelType, panelConfig);

  return {
    title: "",
    panelConfigs: panelConfigs,
  };
}

export function getConfigForPanelType(config: PanelConfig, panel: Panel) {
  const panelType = getPanelType(panel);
  return config.panelConfigs.get(panelType);
}

export function getStartProgram(config: PanelConfig, panel: Panel) {
  const panelConfig = getConfigForPanelType(config, panel);

  if (!panelConfig) {
    return null;
  }

  return panelConfig.programs.get(panelConfig.startProgram);
}

export function getProgram(
  config: PanelConfig,
  panel: Panel,
  programNumber: number
) {
  const panelConfig = getConfigForPanelType(config, panel);

  if (!panelConfig) {
    return null;
  }

  return panelConfig.programs.get(programNumber);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseConfigData(data: any): PanelConfig {
  const title = data.title;
  const panelConfigsData = data.panelConfigs;

  const panelConfigs = new Map<PanelType, PanelTypeSpecificConfig>();

  for (const panelConfigData of panelConfigsData) {
    const panelType = panelConfigData.panelType;
    const startProgram = panelConfigData.startProgram;

    const programs = new Map<number, Program>();

    const programsData = panelConfigData.programs;

    for (const programData of programsData) {
      const programNumber = programData.id;

      const data = {
        name: programData.name,
        description: programData.desc,
        programNumber: programNumber,
      };

      programs.set(programNumber, data);
    }

    panelConfigs.set(panelType, {
      panelType: panelType,
      programs: programs,
      startProgram: startProgram ? startProgram : 1,
    });
  }

  return {
    title: title,
    panelConfigs: panelConfigs,
  };
}

export function getPanelProgramName(
  vue: Vue,
  programNumber: number,
  panel: Panel,
  config?: PanelConfig | null | undefined
) {
  if (!config) {
    return vue
      .$t("panelDetail.formatDryingProgram", [programNumber])
      .toString();
  }

  const program = getProgram(config, panel, programNumber);

  if (!program) {
    return vue
      .$t("panelDetail.formatDryingProgram", [programNumber])
      .toString();
  }

  return vue
    .$t("panelDetail.formatDryingProgramWithName", [
      programNumber,
      programNumber == 0 ? vue.$t("panelDetail.idle") : program.name,
    ])
    .toString();
}
